changeMajor
<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="选择网校">
        <el-select
          v-model="model.maID"
          multiple
          @change="changeMajor"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          v-model="model.chID"
          @change="getCourse"
          multiple
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          v-model="model.coID"
          @change="getClass"
          multiple
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select
          v-model="model.clID"
          @change="changeClass"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="添加老师">
        <el-select v-model="model.teID" multiple placeholder="讲师">
          <el-option
            v-for="item in teacher"
            :key="item.teID"
            :label="item.teName"
            :value="item.teID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="添加班级">
        <el-select v-model="model._id" placeholder="班级">
          <el-option
            v-for="item in getgrade"
            :key="item._id"
            :label="item.grName"
            :value="item._id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="添加课程试听">
        <el-select v-model="model.tvID" multiple placeholder="添加课程试听">
          <el-option
            v-for="item in tvideos"
            :key="item.tvID"
            :label="item.tvName"
            :value="item.tvID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="添加课程目录">
        <el-select v-model="model.conID" multiple placeholder="添加课程目录">
          <el-option
            v-for="item in contents"
            :key="item.index"
            :label="item.conName"
            :value="item.conID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="添加课程大纲">
        <el-select v-model="model.lineID" multiple placeholder="添加课程大纲">
          <el-option
            v-for="item in outline"
            :key="item.lineID"
            :label="item.lineName"
            :value="item.lineID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="添加备考指导">
        <el-select v-model="model.advID" multiple placeholder="添加备考指导">
          <el-option
            v-for="item in advice"
            :key="item.advID"
            :label="item.advName"
            :value="item.advID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="课程名称">
        <el-input style="width: 550px" v-model="model.leName"></el-input>
      </el-form-item>

      <el-form-item label="课程隐显">
        <el-input
          style="width: 150px"
          v-model="model.isShow"
          placeholder="0为隐藏1为显示，默认为1"
        ></el-input>
      </el-form-item>

      <el-card style="margin-top: 25px">
        <!-- 上传封面图 -->
        <h3>上传课程主图</h3>
        <el-upload
          class="avatar-uploader"
          :action="$http.defaults.baseURL + '/category/img/lecover'"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          list-type="picture"
          :on-success="coUpload"
        >
          <div>
            <img
              v-show="showCoImg"
              style="width: 480px; height: 300px"
              :src="model.coverImg"
            />
          </div>
          <el-button size="small" type="primary">点击封面图</el-button>
        </el-upload>
        <el-form-item style="margin-top: 35px" label="详情图网址">
          <el-input style="width: 550px" v-model="model.coverImg"></el-input>
        </el-form-item>
      </el-card>

      <el-card style="margin-top: 25px">
        <!-- 上传课程详情图 -->
        <h3>上传课程详情图</h3>
        <el-upload
          class="avatar-uploader"
          :action="$http.defaults.baseURL + '/category/img/ledetail'"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          list-type="picture"
          :on-success="leUpload"
        >
          <div>
            <img
              v-show="showLeImg"
              style="width: 650px; height: 100%"
              :src="model.leImg"
            />
          </div>
          <el-button size="small" type="primary">点击上传详情图</el-button>
        </el-upload>
        <el-form-item style="margin-top: 35px" label="详情图网址">
          <el-input style="width: 550px" v-model="model.leImg"></el-input>
        </el-form-item>
      </el-card>

      <el-form-item style="margin-top: 25px; margin-left: 165px">
        <el-button type="primary" @click="putLessonEdit">点击修改</el-button>
      </el-form-item>

      <el-form-item style="margin-top: 25px; margin-left: 165px">
        <el-button type="success" @click="copyLesson">点击复制</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    id: {},
  },
  data() {
    return {
      showCoImg: true,
      showLeImg: true,
      dataNum: 1,
      major: [],
      channel: [],
      course: [],
      shclass: [],
      lesson: [],
      teacher: [],
      getgrade: [],
      tvideos: [],
      contents: [],
      outline: [],
      advice: [],
      model: {
        leName: "",
        leImg: "",
        coverImg: "",
        isShow: 1,
      },
      /*  tvideo: [
        { tvideoId: Date.now(), tvideoName: "", tvideoVid: "", tvideoTime: "" },
      ],
      contents: [{ contentsId: Date.now(), contentsName: "", contentsVid: "" }], */

      leImg: "",
    };
  },
  methods: {
    /* 修改课程 */
    async putLessonEdit() {
      try {
        const lesson = {
          maID: this.model.maID,
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
          teID: this.model.teID,
          leName: this.model.leName,
          leImg: this.model.leImg.replace("/static", "static"),
          coverImg: this.model.coverImg.replace("/static", "static"),
          gradeID: this.model._id,
          conID: this.model.conID,
          tvID: this.model.tvID,
          lineID: this.model.lineID,
          advID: this.model.advID,
          isShow: this.model.isShow,
        };

        const result = await this.$http.put(
          "/lesson/putlesson?_id=" + `${this.id}`,
          lesson
        );
        if (result.status == 200) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.$router.push("/lesson/list");
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*  复制课程 */
    async copyLesson() {
      try {
        const lesson = {
          maID: this.model.maID,
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
          teID: this.model.teID,
          leName: this.model.leName,
          leImg: this.model.leImg.replace("/static", "static"),
          coverImg: this.model.coverImg.replace("/static", "static"),
          gradeID: this.model._id,
          conID: this.model.conID,
          tvID: this.model.tvID,
          lineID: this.model.lineID,
          advID: this.model.advID,
          isShow: this.model.isShow,
        };

        const result = await this.$http.post("/lesson/create", lesson);
        if (result.status == 200) {
          this.$message({
            type: "success",
            message: "课程复制成功",
          });
          this.$router.push("/lesson/list");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        //console.log(getchannel);
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      try {
        //console.log(item);
        const getcourse = await this.$http.get(
          "/category/getcourse",
          {
            params: { chID },
          },

          this.getGrade(chID),
          this.getTeacher(chID)
        );
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getContent() {
      try {
        const result = await this.$http.get("/content/getcontent", {
          params: {
            maID: this.model.maID,
            chID: this.model.chID,
            coID: this.model.coID,
            clID: this.model.clID,
            page: this.currentPage,
            size: this.pageSize,
          },
        });

        this.contents = result.data[0]?.result;
      } catch (error) {
        console.log(error);
      }
    },
    async getTvideo() {
      try {
        const result = await this.$http.get("/tvideo/getletvideo", {
          params: {
            maID: this.model.maID,
            chID: this.model.chID,
            coID: this.model.coID,
            clID: this.model.clID,
          },
        });

        this.tvideos = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.shclass = getclass.data;
        this.getGrade(coID);
        this.getTeacher(coID);
      } catch (error) {
        console.log(error);
      }
    },

    async getTeacher() {
      try {
        let params = {
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
          maID: this.model.maID,
        };
        //this.getLesson(params);
        const result = await this.$http.get("/category/geteacher", { params });

        this.teacher = result.data[0].result;
      } catch (error) {
        console.log(error);
      }
    },
    async getAdvices() {
      try {
        let params = {
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
        };
        //this.getLesson(params);
        const result = await this.$http.get("/advice/getleadvice", { params });
        this.advice = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    async changeClass(clID) {
      this.getTeacher(clID);
      this.getOutline(clID);
      this.getAdvices(clID);
    },
    changeMajor() {
      this.getGrade();
      this.getTeacher();
      this.getTvideo();
      this.getContent();
    },
    async getOutline() {
      try {
        let params = {
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
          maID: this.model.maID,
        };
        //this.getLesson(params);

        const result = await this.$http.get("/outline/getleline", { params });

        this.outline = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getGrade() {
      try {
        let params = {
          chID: this.model.chID,
          maID: this.model.maID,
          coID: this.model.coID,
          clID: this.model.clID,
        };
        //console.log(params);
        const getGrade = await this.$http.get("/category/getgrade", {
          params,
        });
        //console.log(getGrade.data[0].result);
        this.getgrade = getGrade.data[0].result;
        //console.log(this.getgrade);
      } catch (error) {
        console.log(error);
      }
    },
    leUpload(res) {
      try {
        //console.log(res.detailImg);
        this.model.leImg = res;
        this.showLeImg = false;
      } catch (error) {
        console.log(error);
      }
    },
    coUpload(res) {
      try {
        //console.log(res.coverImg);
        this.model.coverImg = res;
        this.showCoImg = false;
      } catch (error) {
        console.log(error);
      }
    },
    handlePreview(file) {
      //console.log(file);
    },

    /*  async getlesson() {
      try {
        const getlesson = await this.$http.get("/category/getlesson");
        this.lesson = getlesson.data;
      } catch (error) {
        console.log(error);
      }
    }, */

    handleRemove(uploadFile, uploadFiles) {
      //.log(uploadFile, uploadFiles);
    },

    //课程编辑
    async getEditLesson() {
      try {
        const getEditLesson = await this.$http.get("/lesson/editlesson", {
          params: { id: this.id },
        });
        //console.log(getEditLesson.data[0].grade[0]);
        this.model.maID = getEditLesson.data[0].maID;
        this.model.chID = getEditLesson.data[0].chID;
        this.model.coID = getEditLesson.data[0].coID;
        this.model.clID = getEditLesson.data[0].clID;
        this.model.teID = getEditLesson.data[0].teID;
        this.model.leName = getEditLesson.data[0].leName;
        this.model.leImg = "/" + getEditLesson.data[0].leImg;
        this.model.coverImg = "/" + getEditLesson.data[0].coverImg;
        this.getgrade = getEditLesson.data[0].grade;
        this.model.leID = getEditLesson.data[0].leID;
        this.model.tvID = getEditLesson.data[0].tvID;
        this.model.conID = getEditLesson.data[0].conID;
        this.model.lineID = getEditLesson.data[0].lineID;
        this.model.advID = getEditLesson.data[0].advID;
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    this.id && this.getEditLesson(this.id);
  },
};
</script>

<style scoped></style>
